import React from "react"
//import I18n from "i18n-js/index.js.erb"
import EmailBuilderActions from "./actions/EmailBuilderActions"
import Scheduler from "./Scheduler"
import ErrorHelper from "../Errors/ErrorHelper";

export default class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      setOnce: false,
      body: this.props.email ? this.props.email.body : '',
      status: this.props.email ? this.props.email.status : true,
      email_type: this.props.email && this.props.email.email_type ? this.props.email.email_type : "event",
      testEmailSending: false,
      updated_at: this.props.email ? this.props.email.updated_at : '',
    }
    this.onInsertTextVariables = this.onInsertTextVariables.bind(this)
    this.onChange = this.onChange.bind(this)
    this.sendTestEmail = this.sendTestEmail.bind(this)
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.email && !this.state.setOnce) {
      this.setState({
        setOnce: true,
        body: this.props.email.body,
        status: this.props.email.status,
        email_type: this.props.email.email_type || 'event',
        subject: this.props.email.subject,
        from_address: this.props.email.from_address,
        to_addresses: this.props.email.to_addresses,
        cc_addresses: this.props.email.cc_addresses,
        bcc_addresses: this.props.email.bcc_addresses,
        updated_at: this.props.email.updated_at,
      });
    }
  }

  processAddresses(oldAddresses, newAddresses) {
    if (!oldAddresses) {
      return newAddresses
    } else if (oldAddresses != newAddresses && oldAddresses.indexOf(newAddresses) == -1) {
      return oldAddresses + ', ' + newAddresses;
    } else {
      return oldAddresses;
    }
  }

  render() {
    return (
      <div style={{marginBottom: 18}}>
        <div className="card well-lg">
          <div className="form-group">
            <label>{I18n.t('code')+'*'}</label>
            <br />
            <input
              id="code"
              type="text"
              name="code"
              className={ErrorHelper.renderFieldClasses('code', this.props.errors, 'form-control')}
              value={this.props.email && this.props.email.code ? this.props.email.code : ''}
              maxLength="12"
              onChange={this.onChangeNameOrCode} />
            {ErrorHelper.renderFieldErrors("code", this.props.errors)}
          </div>
          <div className="form-group">
            <label>{I18n.t('name')+'*'}</label>
            <br />
            <input
              type="text"
              name="name"
              className={ErrorHelper.renderFieldClasses('name', this.props.errors, 'form-control')}
              value={this.props.email && this.props.email.name ? this.props.email.name : ''}
              onChange={this.onChangeNameOrCode} />
            {ErrorHelper.renderFieldErrors("name", this.props.errors)}
          </div>

          <Scheduler {...this.state} {...this.props} onChange={this.onChange}/>

          {this.state.email_type == "event"
          ?
          <div className="form-group" style={{marginBottom: 0}}>
            <label>{I18n.t('status')}</label>
            <select name="email[status]" ref="status" className='form-control' value={this.state.status} onChange={this.onChange.bind(null, 'status')}>
              <option value='published'>{I18n.t('published')}</option>
              <option value='draft'>{I18n.t('draft')}</option>
            </select>
          </div>
          :
          null
          }

          <hr className="inside-a-well" />

          <div className="form-group" style={{marginBottom: 0, position: 'relative'}}>
            <label>{I18n.t('send_test_email')}</label>
            <div className="input-group send-test-email-group">
              <input ref="test_email_addresses" type="text" className="form-control" placeholder={I18n.t('email_addresses_comma_separated')} />
              <span className="input-group-btn">
                <button className="btn no-ladda btn-dark" ref="send_test_email_button" type="submit" style={{height: 34}} onClick={this.sendTestEmail}>{I18n.t('send')}</button>
              </span>
            </div>
            {this.state.testEmailSending ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
          </div>

          <input type="hidden" name="email[body]" value={this.props.inputBody || this.state.body || ''} />
          <input type="hidden" name="email[updated_at]" value={this.state.updated_at || ''} />
        </div>

      </div>
    );
  }

  sendTestEmail(event) {
    var self = this;

    event.preventDefault();
    event.stopPropagation();

    self.setState({testEmailSending: true});

    $.ajax({
      type: 'POST',
      url: this.props.sendTestEmailPath,
      data: {
        email: $.extend({}, this.props.email, {to_addresses: $(this.refs.test_email_addresses).val(), body: this.props.tempBody, subject: this.props.tempSubject, cc_addresses: '', bcc_addresses: ''}),
        reservation: {

        },
      }
    }).done((data) => {
      self.setState({testEmailSending: false});

      if (data.error) {
        $(self.refs.test_email_addresses).tooltip({template: '<div class="tooltip tooltip-error" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: 'manual', title: data.error}).tooltip('show');
      } else {
        $(self.refs.test_email_addresses).tooltip({trigger: 'manual', title: data.success}).tooltip('show');
      }

      setTimeout(() => {
        $(self.refs.test_email_addresses).tooltip('destroy').removeAttr('title');
      }, 4000);
    }).fail((data) => {
      self.setState({testEmailSending: false});

      setTimeout(() => {
        $(self.refs.test_email_addresses).tooltip('destroy').removeAttr('title');
      }, 4000);
    });
  }

  onInsertTextVariables(inputName, event) {
    event.stopPropagation();
    event.preventDefault();

    EmailBuilderActions.insertTextVariablesIntoInput(inputName);
  }

  onChange(name, event) {
    var state = this.state;
    state[name] = event.target.value;
    this.setState(state);
    EmailBuilderActions.setValue(name, event.target.value);
  }

  onChangeNameOrCode(e) {
    EmailBuilderActions.setValue(e.target.name, e.target.value);
  };
};
